module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"日連続入力中！":"日連続入力中！"},"en":{"日連続入力中！":"days! Inputting continuously"}}')
  delete Component.options._Ctor
}
